// @flow
import { APICore } from './apiCore';
import config from '../../config';
import { PAGINATION_DEFAULT_VALUE } from '../defaultValue';

const api = new APICore();

type Query = {
    currentPage?: number,
    pageSize?: number,
};

function getLogEntries(query: Query): any {
    const page = query?.currentPage ?? PAGINATION_DEFAULT_VALUE.currentPage;
    const pageSize = query?.pageSize ?? PAGINATION_DEFAULT_VALUE.pageSize;

    let baseUrl = config.LOGGER_URL;

    if (typeof query === 'string') {
        baseUrl += `?${query}`;
    }

    const queryParam = {
        page: page.toString(),
        page_size: pageSize.toString(),
    };

    return api.get(`${baseUrl}`, typeof query === 'object' ? queryParam : undefined, {
        headers: { 'full-response': true },
    });
}

export { getLogEntries };
